import type { WordPack } from "../types";
import type { WordPackDefinition } from "./types";
import { CLASSIC_PACK, CLASSIC_WORDS } from "./classic";
import { KAHOOT_PACK, KAHOOT_WORDS } from "./kahoot";
import { GEOGRAPHY_PACK, GEOGRAPHY_WORDS } from "./geography";
import { POP_CULTURE_PACK, POP_CULTURE_WORDS } from "./popculture";
import { SCIENCE_PACK, SCIENCE_WORDS } from "./science";
import { SPACE_PACK, SPACE_WORDS } from "./space";
import { NATURE_PACK, NATURE_WORDS } from "./nature";

export { CLASSIC_WORDS, CLASSIC_PACK } from "./classic";
export { KAHOOT_WORDS, KAHOOT_PACK } from "./kahoot";
export { GEOGRAPHY_WORDS, GEOGRAPHY_PACK } from "./geography";
export { POP_CULTURE_WORDS, POP_CULTURE_PACK } from "./popculture";
export { SCIENCE_WORDS, SCIENCE_PACK } from "./science";
export { SPACE_WORDS, SPACE_PACK } from "./space";
export { NATURE_WORDS, NATURE_PACK } from "./nature";
export type { WordPackDefinition } from "./types";

export const WORD_PACK_DEFINITIONS: Record<WordPack, WordPackDefinition> = {
  classic: CLASSIC_PACK,
  kahoot: KAHOOT_PACK,
  geography: GEOGRAPHY_PACK,
  popculture: POP_CULTURE_PACK,
  science: SCIENCE_PACK,
  space: SPACE_PACK,
  nature: NATURE_PACK,
};

export function getWordPackDefinition(pack: WordPack): WordPackDefinition {
  return WORD_PACK_DEFINITIONS[pack];
}
